import { render, staticRenderFns } from "./HeaderFrame.vue?vue&type=template&id=cda7c0e0&scoped=true&"
import script from "./HeaderFrame.vue?vue&type=script&lang=js&"
export * from "./HeaderFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda7c0e0",
  null
  
)

export default component.exports